






















































import { Component, Vue } from "vue-property-decorator";
import { Validate } from "vuelidate-property-decorators";
import { required, url } from "vuelidate/lib/validators";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { i18n } from "@/resources/locales";
import AutoPlayValidador from "@/resources/mixins/autoPlayValidator";
@Component({
  name: "meeting-url-component",
})
export default class MeetingUrlComponent extends mixins(
  NotificationEvent,
  AutoPlayValidador
) {
  @Validate({ url, required })
  url = "";
  idRoom = 0;
  autoplay = false;
  loading = false;
  mounted() {
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    const loading = this.$vs.loading({
      target: this.$refs.content,
    });
    this.$store.dispatch("SpaceStore/getRoomAction", {
      roomId: roomId,
      callback: (response) => {
        this.autoplay = this.getAutoplay(this.autoplay,response.videoUrl);
        this.url = response.videoUrl ? response.videoUrl : undefined;
        this.loading = false;
        loading.close();
      },
      callbackError: (error) => {
        this.onError(
          i18n.t("notifications.titles.error"),
          i18n.t("notifications.genericError.genericErrorRetry")
        );
        this.loading = false;
        loading.close();
      },
    });
  }
  get active(): boolean {
    return this.$store.getters["MeetingStore/getOpenMeetingUrl"];
  }
  set active(e) {
    this.$store.dispatch("MeetingStore/setOpenMeetingUrlAction", e);
  }
  async onSave(): Promise<void> {
    this.url = this.setAutoplay(this.url,this.autoplay);
    await this.changeVideoUrl();
  }
  async deleteUrl(): Promise<void> {
    this.url = "";
    await this.changeVideoUrl();
  }
  async changeVideoUrl(): Promise<void> {
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    await this.$store.dispatch("MeetingStore/changeVideoUrlAction", {
      roomId,
      data: { videoUrl: this.url },
      callback: async (response) => {
        this.active = false;
      },
      callbackError: async (error) => {},
    });
  }
}
